import _defineProperty from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/**
 * @file Created on Thu Jul 19 2018
 * @author BPo
 */


import axios from 'axios';
import { stringify } from 'querystring';
import { CONSTANTS } from '../../constants';
import logger from '../logger';
import { getKeycloakStore } from '../stores/helpers/getKeycloakStore';
import { session } from '../../shared/storage';
import { HeaderNames, Utils } from '@logio/common-be-fe';
import rootStore from '../stores/RootStore';
import { StoreName } from '../stores/StoreName';
/**
 * Returns forced keycloak bearer or the original one.
 * @param keycloak Keycloak instance
 */

var getToken = function getToken(keycloak) {
  if (Utils.isValueMissing(CONSTANTS.KEYCLOAK.CONFIG.bearer)) {
    if (keycloak && keycloak.token) {
      return "Bearer ".concat(keycloak.token);
    }

    return '';
  }

  return "Bearer ".concat(CONSTANTS.KEYCLOAK.CONFIG.bearer);
}; // Middleware for the api requests


var instance = axios.create({
  baseURL: CONSTANTS.APP.API_HOST,
  timeout: CONSTANTS.API.OPTIONS.TIMEOUT
});
/**
 * Intercept every response and handle all necessary auth 4xx response
 */

instance.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var originalRequest, keycloakStore, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // filter error code
            originalRequest = error.config; // When error is 401 and has not been retried already

            if (!(error.response && error.response.status === 401 && !originalRequest.retry)) {
              _context.next = 18;
              break;
            }

            originalRequest.retry = true;
            keycloakStore = getKeycloakStore();
            _context.prev = 4;
            _context.next = 7;
            return keycloakStore.refreshToken();

          case 7:
            // send original request with new token
            originalRequest.headers.Authorization = getToken(keycloakStore.keycloak);
            _context.next = 10;
            return axios.request(originalRequest);

          case 10:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](4);
            logger.error('Refresh token failed, or the session has expired');
            keycloakStore.keycloak.logout();

          case 18:
            console.error(error);
            throw error;

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 14]]);
  }));
});
export var Api =
/*#__PURE__*/
function () {
  function Api(endpoint, auth) {
    _classCallCheck(this, Api);

    this.endpoint = endpoint;
    this.q = {};
    this.headers = {};
    this.messageStore = rootStore.getStore(StoreName.Message);
    /**
     * Transforms query arrays in the Koa way
     * [Providing an array as a param isn't working as expected. #604]{@link https://github.com/axios/axios/issues/604#issuecomment-403035498}
     */

    this.paramsSerializer = function (params) {
      var options = '';

      var _loop = function _loop(key) {
        if (typeof params[key] !== 'object') {
          options += params[key] ? "".concat(key, "=").concat(params[key], "&") : '';
        } else if (params[key] && typeof params[key] === 'object' && params[key].length) {
          params[key].forEach(function (el) {
            options += "".concat(key, "=").concat(el, "&");
          });
        }
      };

      for (var key in params) {
        _loop(key);
      }

      return options ? options.slice(0, -1) : options;
    };

    this.headers['Content-Type'] = 'application/json';

    if (auth) {
      this.auth();
    }
  }

  _createClass(Api, [{
    key: "query",
    value: function query(_query) {
      this.q = _query;
      return this;
    }
  }, {
    key: "setHeaders",
    value: function setHeaders(headers) {
      var _this = this;

      Object.keys(headers).forEach(function (key) {
        if (headers[key] == null) {
          delete _this.headers[key];
        } else {
          _this.headers[key] = headers[key];
        }
      });
      return this;
    }
  }, {
    key: "auth",
    value: function auth() {
      var token = getToken(getKeycloakStore().keycloak);

      if (token) {
        this.setHeaders({
          Authorization: getToken(getKeycloakStore().keycloak)
        });
      }

      if (!Utils.isValueMissing(session.get(CONSTANTS.KEYCLOAK.SUBSTITUTED_USER_ID))) {
        this.setHeaders(_defineProperty({}, HeaderNames.X_PP_SUBSTITUTED_USER, session.get(CONSTANTS.KEYCLOAK.SUBSTITUTED_USER_ID)));
      }

      return this;
    }
    /**
     * Perform get request
     * @param config Relevant axios config.
     */

  }, {
    key: "get",
    value: function get(config) {
      var _this2 = this;

      return instance.get(this.getURL(), this.getConfig(config)).catch(function (error) {
        _this2.messageStore.setError(error);

        throw error;
      });
    }
    /**
     * Perform put request
     * Note: Url, method, and data properties don't need to be specified in config.
     * @param data A JavaScript value, usually an object or array
     * @param config Relevant axios config.
     */

  }, {
    key: "put",
    value: function put(data, config) {
      var _this3 = this;

      return instance.put(this.getURL(), data, this.getConfig(config)).catch(function (error) {
        _this3.messageStore.setError(error);

        throw error;
      });
    }
    /**
     * Perform post request
     * Note: Url, method, and data properties don't need to be specified in config.
     * @param data A JavaScript value, usually an object or array
     * @param config Relevant axios config.
     */

  }, {
    key: "post",
    value: function post(data, config) {
      var _this4 = this;

      return instance.post(this.getURL(), data, this.getConfig(config)).catch(function (error) {
        _this4.messageStore.setError(error);

        throw error;
      });
    }
    /**
     * Perform patch request
     * Note: Url, method, and data properties don't need to be specified in config.
     * @param data A JavaScript value, usually an object or array
     * @param config Relevant axios config.
     */

  }, {
    key: "patch",
    value: function patch(data, config) {
      var _this5 = this;

      return instance.patch(this.getURL(), data, this.getConfig(config)).catch(function (error) {
        _this5.messageStore.setError(error);

        throw error;
      });
    }
    /**
     * Perform delete request
     * Note: Url, method, and data properties don't need to be specified in config.
     * @param config Relevant axios config.
     */

  }, {
    key: "delete",
    value: function _delete(config) {
      var _this6 = this;

      return instance.delete(this.getURL(), this.getConfig(config)).catch(function (error) {
        _this6.messageStore.setError(error);

        throw error;
      });
    }
    /**
     * When query string set url will be merged with the given query string.
     */

  }, {
    key: "getURL",
    value: function getURL() {
      var queryString = stringify(this.q);
      return queryString.length ? "".concat(this.endpoint, "?").concat(queryString) : this.endpoint;
    }
    /**
     * Merge custom and passed config.
     * @param config Relevant axios config.
     */

  }, {
    key: "getConfig",
    value: function getConfig() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return Object.assign({
        headers: this.headers,
        paramsSerializer: this.paramsSerializer
      }, config);
    }
    /**
     * Converts data to a JavaScript Object Notation (JSON) string if set.
     * @param data A JavaScript value, usually an object or array, to be converted.
     */

  }, {
    key: "getPostData",
    value: function getPostData(data) {
      // FIXME: Form data parsing should be used?
      return data ? JSON.stringify(data) : null;
    }
  }]);

  return Api;
}();